module.exports = __webpack_public_path__ + "static/og-meta-img-89879b87520e8cf397854d9dbf4d33ff.png";